export default {
      id: "icon-mobile-menu-contact-usage",
      viewBox: "0 0 22 16",
      url: "../icon/" + "icons.svg#icon-mobile-menu-contact-usage",
      toString: function () {
        return this.url;
      }
    }